import { Grid, Typography } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React from "react";
import { Helmet } from "react-helmet-async";
import {
  Link,
  NavLink,
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { teacherArticles } from "./Help";

const useStyles = makeStyles((theme) => ({
  rootbase: {
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      minHeight: `calc(100vh - 200px)`,
      overflow: "visible",
    },
  },
  root: {
    width: "100%",
    marginTop: "70px",
  },
  faqTopics: {
    backgroundColor: "#f7f7f7",
    height: "100vh",
    paddingLeft: "50px",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    overflow: "scroll",

    "& li": {
      color: "#646f79",
      listStyleType: "none",
      margin: "15px 10px",
      fontWeight: "600",
      fontSize: "16px",
      padding: "5px ",
    },
    "& li:hover": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
      cursor: "pointer",
    },
    "& li.active": {
      color: "#9287FF",
      boxShadow: "-3px 0 0 0 #9287FF",
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      paddingTop: "20px",
      paddingLeft: "10px",
    },
  },
  faqWrapper: {
    paddingTop: "60px",
    position: "sticky",
    height: `calc(100% - 70px)`,
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      padding: "0 10px",
    },
  },
  fontHeading: {
    color: "#646f79",
    textDecoration: "underline",
    fontWeight: 700,
  },
  hyperlink: {
    color: "#8277FF !important",
    textDecoration: "none",
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: "0 0 0 1.5px #646f79",
    display: "flex",
    flexWrap: "nowrap",
    margin: "10px 20px 40px 0px",
  },
  searchIcon: {
    height: "100%",
    position: "relative",
    display: "flex",
    alignSelf: "center",
    right: "10px",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
  },
  categoryMain: {
    width: "100%",
    height: `calc(100vh - 70px)`,
    overflow: "auto",
    paddingLeft: "30px",
    paddingBottom: "30px",
    paddingRight: "10px",
    color: "#151b26",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      overflow: "visible",
    },
  },
  catLink: {
    color: "#4381b5",
    display: "table",
    marginTop: "20px",
  },
  subCat: {
    marginTop: "40px",
    textDecoration: "underline",
    color: "#646f79",
    "&:after": {
      content: '":"',
    },
  },
  subCat1: {
    textDecoration: "underline",
    color: "#646f79",
    margin: "10px 0px",
  },
  topicSubCat: {
    textDecoration: "underline",
    color: "#646f79",
  },
  arrowIcon: {
    fontSize: "14px",
    color: "#9287FF",
    marginRight: "7px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#9287FF",
  },
  catList: {
    padding: "0px",
  },
}));

function KeyIdeas() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Key Ideas</Typography>
      <Typography variant="h6" className={classes.subCat}>
        General info
      </Typography>
      {teacherArticles
        .filter((article) => article.Category === "Key ideas")
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/key-idea-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}

function CreateAnswerKey() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">How to create an answer key</Typography>

      <Typography variant="h6" className={classes.subCat}>
        General info
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Creating an answer key" &&
            article.SubCategory === "General info"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/create-answer-key-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
      <Typography variant="h6" className={classes.subCat}>
        Inputting answers
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Creating an answer key" &&
            article.SubCategory === "Inputting answers"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/create-answer-key-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
      <Typography variant="h6" className={classes.subCat}>
        Tips and Tricks
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Creating an answer key" &&
            article.SubCategory === "Tips and tricks"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/create-answer-key-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}

function DifferentAnswerTypes() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Our different answer types</Typography>
      <div style={{ marginTop: "40px" }}></div>

      {teacherArticles
        .filter((article) => article.Category === "Our different answer types")
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/different-answer-types-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}

function AnswerSheets() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Answer sheets</Typography>
      <Typography variant="h6" className={classes.subCat}>
        General info
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Answer sheets" &&
            article.SubCategory === "General info"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/answer-sheet-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
      <Typography variant="h6" className={classes.subCat}>
        Paper answer sheets
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Answer sheets" &&
            article.SubCategory === "Paper answer sheets"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/answer-sheet-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
      <Typography variant="h6" className={classes.subCat}>
        Online answer sheets
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Answer sheets" &&
            article.SubCategory === "Online answer sheets"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/answer-sheet-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}
function ScanningPaperAnswerSheets() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Scanning paper answer sheets</Typography>
      <div style={{ marginTop: "40px" }}></div>

      {teacherArticles
        .filter(
          (article) => article.Category === "Scanning paper answer sheets"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/scanning-paper-answer-sheets-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}
function HandwritingRec() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">Handwriting recognition accuracy</Typography>
      <div style={{ marginTop: "40px" }}></div>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "Handwriting recognition accuracy" &&
            article.SubCategory === ""
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/handwriting-topics/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}
function Viewresults() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h4">View and send results</Typography>
      <Typography variant="h6" className={classes.subCat}>
        General info
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "View and send results" &&
            article.SubCategory === "General info"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/view-and-send/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
      <Typography variant="h6" className={classes.subCat}>
        Actions
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "View and send results" &&
            article.SubCategory === "Actions"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/view-and-send/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
      <Typography variant="h6" className={classes.subCat}>
        Tips and tricks
      </Typography>
      {teacherArticles
        .filter(
          (article) =>
            article.Category === "View and send results" &&
            article.SubCategory === "Tips and tricks"
        )
        .map((article, index) => {
          return (
            <Link
              to={`/help-topics/view-and-send/${article.Link}`}
              className={classes.catLink}
              key={index}
            >
              {article.Topic}
            </Link>
          );
        })}
    </div>
  );
}

function HelpOptions() {
  const { url, path } = useRouteMatch();

  const location = useLocation();
  const { pathname } = location;

  const allOptions = teacherArticles;

  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>
          Help Topics, Tips and Resources to Learn More About SwiftGrade
        </title>
        <meta
          name="description"
          content="SwiftGrade can grade both paper and online assessments making it great for virtual, in-person, or hybrid learning. Helping teachers reduce grading load for handwritten assessments by 80-90%."
        />
      </Helmet>
      <div className={classes.rootbase}>
        <Grid container>
          <Grid item xs={12} sm={3} className={classes.faqTopics}>
            <div className={classes.faqWrapper}>
              <Grid container direction="row" alignItems="center">
                <Link
                  to={`/`}
                  style={{ display: "flex" }}
                  className={classes.breadcrumb}
                >
                  <ArrowBackIcon className={classes.arrowIcon} />
                </Link>
                <Link
                  to={`/`}
                  style={{ textDecoration: "none" }}
                  className={classes.breadcrumb}
                >
                  Help Center
                </Link>
              </Grid>
              <Autocomplete
                id="complete"
                options={allOptions}
                openOnFocus={true}
                getOptionLabel={(option) => option.Topic}
                renderOption={(option) => (
                  <Link
                    style={{
                      width: "100%",
                      color: "black",
                      height: "100%",
                      textDecoration: "none",
                    }}
                    to={`/help-topics/${option.Sublink}/${option.Link}`}
                  >
                    <div
                      style={{
                        height: "100%",
                        margin: "5px 0px 5px 20px",
                      }}
                    >
                      {option.Topic}
                    </div>
                  </Link>
                )}
                renderInput={(params) => (
                  <div ref={params.InputProps.ref} className={classes.search}>
                    <InputBase
                      {...params.inputProps}
                      placeholder="Search"
                      classes={{
                        root: classes.inputRoot,
                        input: classes.inputInput,
                      }}
                      inputProps={{ "aria-label": "search" }}
                    />
                    <div className={classes.searchIcon}>
                      <SearchIcon />
                    </div>
                  </div>
                )}
              />
              <ul className={classes.catList} id="topicList">
                <Link
                  to={`${url}/key-ideas`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={pathname.includes("key-ideas") ? "active" : ""}
                  >
                    Key ideas
                  </li>
                </Link>
                <Link
                  to={`${url}/create-answer-key`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("create-answer-key") ? "active" : ""
                    }
                  >
                    Creating an answer key
                  </li>
                </Link>
                <Link
                  to={`${url}/different-answer-types`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("different-answer-types")
                        ? "active"
                        : ""
                    }
                  >
                    Our different answer types
                  </li>
                </Link>
                <Link
                  to={`${url}/answer-sheets`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("/answer-sheets") ? "active" : ""
                    }
                  >
                    Answer sheets
                  </li>
                </Link>
                <Link
                  to={`${url}/scanning-paper-answer-sheets`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("/scanning-paper-answer-sheets")
                        ? "active"
                        : ""
                    }
                  >
                    Scanning paper answer sheets
                  </li>
                </Link>
                <NavLink
                  to={`${url}/view-results`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("view-results") ? "active" : ""
                    }
                  >
                    View and send results
                  </li>
                </NavLink>
                <NavLink
                  to={`${url}/handwriting-rec`}
                  style={{ textDecoration: "none" }}
                >
                  <li
                    className={
                      pathname.includes("handwriting-rec") ? "active" : ""
                    }
                  >
                    Handwriting recognition accuracy
                  </li>
                </NavLink>
              </ul>
            </div>
          </Grid>
          <Grid item xs={12} sm={9} className={classes.categoryMain}>
            <Switch>
              <Route exact path={`${path}`}>
                <Redirect to="/help-options/key-ideas" />
              </Route>
              <Route path={`${path}/key-ideas`}>
                <KeyIdeas />
              </Route>
              <Route path={`${path}/create-Answer-Key`}>
                <CreateAnswerKey />
              </Route>
              <Route path={`${path}/different-answer-types`}>
                <DifferentAnswerTypes />
              </Route>
              <Route path={`${path}/answer-Sheets`}>
                <AnswerSheets />
              </Route>
              <Route path={`${path}/scanning-paper-answer-sheets`}>
                <ScanningPaperAnswerSheets />
              </Route>
              <Route path={`${path}/handwriting-Rec`}>
                <HandwritingRec />
              </Route>
              <Route path={`${path}/view-results`}>
                <Viewresults />
              </Route>
            </Switch>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
export default HelpOptions;
